import { getType } from 'typesafe-actions';

import { MarketCalendar, PublicHoliday } from '../types';

import {
  getCalendars,
  getHolidays,
  setSelectedCalendars,
  setSelectedYear,
} from './actions';

export interface PublicHolidayCalendarState {
  selectedYear: number;
  selectedCalendarIds: number[];
  calendars: MarketCalendar[];
  calendarsLoading: boolean;
  holidays: Record<number, PublicHoliday[]>;
  loading: boolean;
}

const currentYear = new Date().getFullYear();

const initialState: PublicHolidayCalendarState = {
  selectedYear: [2025, 2026, 2027].includes(currentYear) ? currentYear : 2025,
  selectedCalendarIds: [],
  calendars: [],
  calendarsLoading: false,
  holidays: {},
  loading: false,
};

export const publicHolidayCalendarReducer = (
  state = initialState,
  action: any,
): PublicHolidayCalendarState => {
  switch (action.type) {
    case getType(getCalendars.request):
      return { ...state, calendarsLoading: true };

    case getType(getCalendars.success):
      return {
        ...state,
        calendarsLoading: false,
        calendars: action.payload.calendars,
      };

    case getType(getCalendars.failure):
      return { ...state, calendarsLoading: false };

    case getType(getHolidays.request):
      return { ...state, loading: true };

    case getType(getHolidays.success):
      return {
        ...state,
        loading: false,
        holidays: {
          ...state.holidays,
          [action.payload.year]: action.payload.holidays,
        },
      };

    case getType(getHolidays.failure):
      return { ...state, loading: false };

    case getType(setSelectedYear):
      return { ...state, selectedYear: action.payload };

    case getType(setSelectedCalendars):
      return { ...state, selectedCalendarIds: action.payload };

    default:
      return state;
  }
};
